import { createParser } from "nuqs";
import { CrmSystemIds } from "../lib/_core/crmSystem/crmSystem.types.gen";

export const parseAsCrmSystemId = createParser({
    parse: (value: string) => value as CrmSystemIds,
    serialize: (value: CrmSystemIds) => value
});